import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Sidebar from './Sidebar.js';
import { useNavigate } from 'react-router-dom'; // Use useNavigate from react-router-dom
import Footer from './Footer.js';  // Import Footer component
import { BASE_URL } from "./Constants.js";
import { BASE_URL1 } from "./Constants.js";

const Manage_User = () => {
  const [showModal, setShowModal] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [users, setUsers] = useState([]); // State to store users data
  const [user, setUser] = useState([]); // State to store user data
  const [paymentStatusFilter, setPaymentStatusFilter] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [error, setError] = useState(null); // State for error handling
  const [dressTypes, setDressTypes] = useState([]); // State to store dress types
  const [dressSizes, setDressSizes] = useState([]); // State to store dress sizes
  const [dressColors, setDressColors] = useState([]); // State to store dress colors
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [searchQuery, setSearchQuery] = useState(''); // Search query state
  const [departmentFilter, setDepartmentFilter] = useState(''); // Department filter state
  const [Locations, setLocations] = useState([]);

  const [locationFilter, setLocationFilter] = useState(''); // Location filter state
  const [genderFilter, setGenderFilter] = useState(''); // Gender filter state

  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  // /const [usersPerPage] = useState(10); // Users per page for pagination

  const navigate = useNavigate(); // Use useNavigate for page navigation
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle department filter change
  const handleDepartmentFilterChange = (e) => {
    setDepartmentFilter(e.target.value);
  };

  // Handle location filter change
  const handleLocationFilterChange = (e) => {
    setLocationFilter(e.target.value);
  };

  // Handle gender filter change
  const handleGenderFilterChange = (e) => {
    setGenderFilter(e.target.value);
  };

  // Handle page change for pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const profile_details = sessionStorage.getItem('userProfile');
  console.log("session_values", profile_details);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setError('No token found!');
        setLoading(false);
        return;
      }

      try {
        // Fetch profile to check if the user is an admin
        const profileResponse = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const profileData = await profileResponse.json();
        if (profileData && profileData.profile) {
          setUser(profileData.profile.is_uniform_access_given); // Safely access is_admin if profile exists
        } else {
          setError('Profile data not found');
        }

        // Fetch users data
        const usersResponse = await fetch(`${BASE_URL}candidates`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const usersData = await usersResponse.json();
        if (usersData && usersData.employees && Array.isArray(usersData.employees)) {
          setUsers(usersData.employees);
        } else {
          setError('No users found');
        }


      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this effect runs once on component mount

  useEffect(() => {
    const fetchDepts = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}get_depts`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }

        const data = await response.json();
        if (data && data.status && Array.isArray(data.data)) {
          setDepartments(data.data); // Save the department list
        } else {
          setError('No departments found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDepts();
  }, []);

  useEffect(() => {
    const fetchLocs = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}get_locs`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }

        const data = await response.json();
        if (data && data.status && Array.isArray(data.data)) {
          setLocations(data.data); // Save the department list
        } else {
          setError('No departments found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLocs();
  }, []);


  const exportToExcel = () => {
    const exportData = filteredUsers.map(user => ({
      ID: user.id,
      Date: user.created_on?.substring(0, 10) || 'Not provided',
      Name: user.candidate_name,
      Gender: user.gender,
      Department: user.department,
      Location: user.location,
      'Payment Mode': user.payment_mode,
      'Payment Status': user.payment_status,
      'Payment Date': user.payment_date || 'Not provided',
      'Total Amount': user.cost
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, `User_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  // Filter users based on search and filter criteria
  const filteredUsers = users.filter(user => {
    const searchLower = searchQuery.toLowerCase();

    const matchesGlobalSearch = Object.values(user).some(value =>
      value && value.toString().toLowerCase().includes(searchLower)
    );

    const createdDate = user.payment_date?.substring(0, 10);
    const matchesPaymentDate = user.payment_date !== null && user.payment_date !== '';
    const matchesDept = !departmentFilter || user.department === departmentFilter;
    const matchesLoc = !locationFilter || user.location === locationFilter;
    const matchesGender = !genderFilter || user.gender === genderFilter;
    const matchesPayment = !paymentStatusFilter || user.payment_status === paymentStatusFilter;
    const matchesFromDate = !fromDate || createdDate >= fromDate;
    const matchesToDate = !toDate || createdDate <= toDate;

    return matchesGlobalSearch && matchesDept && matchesLoc && matchesGender && matchesPayment && matchesFromDate && matchesToDate && matchesPaymentDate;
  });


  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  return (
    <div className='page-wrapper'>
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '250px' : '0',
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                  <label htmlFor="itemsPerPage" className="me-2 mb-0">Items per page:</label>
                  <select
                    id="itemsPerPage"
                    className="form-select"
                    style={{ width: '100px' }}
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </div>

                <button className="btn btn-success" onClick={exportToExcel}>
                  <i className="fa fa-download me-1"></i> Export to Excel
                </button>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  {/* Filter Controls */}
                  <div className="d-flex flex-wrap gap-2 mb-3 align-items-center">

                    {/* Search by Name */}
                    <div style={{ flex: '1 1 200px', minWidth: '180px' }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by any field"
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                      />
                    </div>

                    {/* From Date */}
                    <div style={{ flex: '1 1 150px', minWidth: '140px' }}>
                      <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={e => setFromDate(e.target.value)}
                      />
                    </div>

                    {/* To Date */}
                    <div style={{ flex: '1 1 150px', minWidth: '140px' }}>
                      <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={e => setToDate(e.target.value)}
                      />
                    </div>

                    {/* Department */}
                    <div style={{ flex: '1 1 200px', minWidth: '180px' }}>
                      <select
                        className="form-control"
                        value={departmentFilter}
                        onChange={e => setDepartmentFilter(e.target.value)}
                      >
                        <option value="">All Departments</option>
                        {departments.map((d, i) => (
                          <option key={i} value={d.EREC_APVC_Dept}>
                            {d.EREC_APVC_Dept}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Location */}
                    <div style={{ flex: '1 1 200px', minWidth: '180px' }}>
                      <select
                        className="form-control"
                        value={locationFilter}
                        onChange={e => setLocationFilter(e.target.value)}
                      >
                        <option value="">All Locations</option>
                        {Locations.map((l, i) => (
                          <option key={i} value={l.EREC_MKOF_lblCity}>
                            {l.EREC_MKOF_lblCity}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Gender */}
                    <div style={{ flex: '1 1 160px', minWidth: '140px' }}>
                      <select
                        className="form-control"
                        value={genderFilter}
                        onChange={e => setGenderFilter(e.target.value)}
                      >
                        <option value="">All Genders</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>

                    {/* Payment Status */}
                    <div style={{ flex: '1 1 160px', minWidth: '140px' }}>
                      <select
                        className="form-control"
                        value={paymentStatusFilter}
                        onChange={e => setPaymentStatusFilter(e.target.value)}
                      >
                        <option value="">All Status</option>
                        <option value="Approved">Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Rejected">Rejected</option>
                      </select>
                    </div>
                  </div>

                  {/* Table (unchanged part) */}
                  <div className="table-responsive table--no-card m-b-30">
                   
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Date of Paid</th>
                          <th>Name</th>
                          <th>Gender</th>
                          <th>Department</th>
                          <th>Location</th>
                          <th>Payment Mode</th>
                          <th>Payment Status</th>
                          <th>Payment Date</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers.map((user) => (
                          <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.created_on ? user.created_on.substring(0, 10) : 'Not provided'}</td>
                            <td>{user.candidate_name}</td>
                            <td>{user.gender}</td>
                            <td>{user.department}</td>
                            <td>{user.location}</td>
                            <td>{user.payment_mode}</td>
                            <td>{user.payment_status}</td>
                            <td>{user.payment_date}</td>
                            <td className="text-right">{user.cost}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="pagination mt-3">
                     <div style = {{ padding: '10px'}}>
                      <strong>Total Records:</strong> {filteredUsers.length}
                    </div>
                    <nav>
                      <ul className="pagination">

                        {/* Previous Button */}
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            &lt;
                          </button>
                        </li>

                        {/* Visible Page Numbers (Max 5) */}
                        {(() => {
                          const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
                          const pageNumbers = [];
                          const maxVisiblePages = 5;

                          let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                          let endPage = startPage + maxVisiblePages - 1;

                          if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - maxVisiblePages + 1);
                          }

                          for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                          }

                          return pageNumbers.map((num) => (
                            <li key={num} className={`page-item ${currentPage === num ? 'active' : ''}`}>
                              <button className="page-link" onClick={() => handlePageChange(num)}>
                                {num}
                              </button>
                            </li>
                          ));
                        })()}

                        {/* Next Button */}
                        <li
                          className={`page-item ${currentPage === Math.ceil(filteredUsers.length / itemsPerPage) ? 'disabled' : ''
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === Math.ceil(filteredUsers.length / itemsPerPage)}
                          >
                            &gt;
                          </button>
                        </li>

                      </ul>
                    </nav>
                  </div>


                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />


    </div>
  );
};

export default Manage_User;